import {assert} from 'assert-ts';
import type {DataValue, Part} from 'schemaDefinition/types';

export const mapValueGetter = (part: Part, value: DataValue) => {
  assert(!Array.isArray(part), 'mapValueGetter: part is array');

  /**
   * Date values can only be one value.
   */
  const firstDateValue = Array.isArray(value) ? value?.[0] : value;

  switch (part.type) {
    case 'date':
      return typeof firstDateValue !== 'object' &&
        new Date(firstDateValue?.toString()).toString() !== 'Invalid Date'
        ? new Date(firstDateValue?.toString())
        : undefined;
    case 'year':
      return Number(value);
    default:
      return value;
  }
};
